import { render, staticRenderFns } from "./CentralizedIssuesFiltersHeader.vue?vue&type=template&id=52cd2565&scoped=true"
import script from "./CentralizedIssuesFiltersHeader.vue?vue&type=script&lang=js"
export * from "./CentralizedIssuesFiltersHeader.vue?vue&type=script&lang=js"
import style0 from "./CentralizedIssuesFiltersHeader.vue?vue&type=style&index=0&id=52cd2565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd2565",
  null
  
)

export default component.exports